<div class="menu-container">
  <app-breadcrumb [title]="'Menu' | transloco" navIcon="hamburger"></app-breadcrumb>
  <!-- <app-server-time></app-server-time> -->
  <app-menu></app-menu>
</div>
